import React from "react";
import ReactDOM from "react-dom";
import { useSelector, useDispatch } from "react-redux";
import * as ProcessActions from "../../redux/actions/process.actions";

function IconVersion() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7l10 5 10-5-10-5z" />
      <path d="M2 17l10 5 10-5" />
      <path d="M2 12l10 5 10-5" />
    </svg>
  );
}
function IconClose() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  );
}

function VersionsPanel({ onClose, id, header, selectedRecord, versions, requesting, dispatch }) {
  const [selected, setSelected] = React.useState(null);
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => { requestAnimationFrame(() => setVisible(true)); }, []);
  React.useEffect(() => {
    if (versions.length > 0 && selected == null) {
      setSelected(versions[0].version);
    }
  }, [versions]);

  const entityLabel = React.useMemo(() => {
    if (!selectedRecord) return String(id);
    const vals = Object.values(selectedRecord);
    return vals.length > 1 ? String(vals[1] || id) : String(id);
  }, [selectedRecord, id]);

  const handleSave = () => {
    if (selected == null) return;
    const versionObj = versions.find(v => v.version === selected);
    dispatch(ProcessActions.processData("flows", "set-flow-version", {
      id,
      version: selected,
      flowdefinition: versionObj?.definition || "",
    }, header));
    handleClose();
  };

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 220);
  };

  return ReactDOM.createPortal(
    <>
      <div onClick={handleClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 9998, opacity: visible ? 1 : 0, transition: "opacity 0.22s ease" }} />

      <div style={{ position: "fixed", top: 0, right: 0, width: 420, height: "100vh", background: "#fff", zIndex: 9999, display: "flex", flexDirection: "column", boxShadow: "-6px 0 40px rgba(0,0,0,0.18)", fontFamily: '"72","72full",Arial,Helvetica,sans-serif', transform: visible ? "translateX(0)" : "translateX(100%)", transition: "transform 0.24s cubic-bezier(0.4,0,0.2,1)" }}>

        {/* Header */}
        <div style={{ background: "linear-gradient(135deg, #0d1117 0%, #1e1b4b 100%)", color: "#f1f5f9", padding: "20px 20px 16px", flexShrink: 0 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 36, height: 36, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <IconVersion />
              </div>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700, lineHeight: 1.2 }}>Definir Versión</div>
                <div style={{ fontSize: 11, opacity: 0.7, marginTop: 2, letterSpacing: 0.3 }}>Selecciona la versión activa del flujo</div>
              </div>
            </div>
            <button onClick={handleClose} style={{ background: "rgba(255,255,255,0.12)", border: "none", borderRadius: 6, color: "#fff", cursor: "pointer", padding: "5px 6px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <IconClose />
            </button>
          </div>

          <div style={{ marginTop: 14, background: "rgba(255,255,255,0.1)", borderRadius: 8, padding: "8px 12px", display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 30, height: 30, background: "rgba(255,255,255,0.22)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, flexShrink: 0 }}>
              {String(entityLabel).charAt(0).toUpperCase()}
            </div>
            <div>
              <div style={{ fontSize: 10, opacity: 0.65, letterSpacing: 0.5, textTransform: "uppercase" }}>Flujo</div>
              <div style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.25 }}>{entityLabel}</div>
            </div>
          </div>
        </div>

        {/* Summary bar */}
        <div style={{ padding: "8px 16px", borderBottom: "1px solid #e5e7eb", background: "#f0f9ff", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <span style={{ fontSize: 12, color: "#0369a1" }}>
            {versions.length} versión{versions.length !== 1 ? "es" : ""} disponible{versions.length !== 1 ? "s" : ""}
          </span>
          {selected != null && (
            <span style={{ fontSize: 12, fontWeight: 600, color: "#0369a1", background: "#e0f2fe", padding: "2px 8px", borderRadius: 10 }}>
              v{selected} seleccionada
            </span>
          )}
        </div>

        {/* Version list */}
        <div style={{ flex: 1, overflowY: "auto", padding: "6px 0" }}>
          {requesting ? (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: 160, gap: 12, color: "#9ca3af" }}>
              <div style={{ width: 22, height: 22, border: "3px solid #e5e7eb", borderTopColor: "#0891b2", borderRadius: "50%", animation: "dlg-spin 0.7s linear infinite" }} />
              <span style={{ fontSize: 13 }}>Cargando versiones...</span>
            </div>
          ) : versions.length === 0 ? (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: 160, gap: 10, color: "#9ca3af" }}>
              <span style={{ fontSize: 32 }}>📭</span>
              <span style={{ fontSize: 13 }}>No hay versiones disponibles</span>
            </div>
          ) : versions.map(v => {
            const isSelected = selected === v.version;
            return (
              <div
                key={v.version}
                onClick={() => setSelected(v.version)}
                style={{ display: "flex", alignItems: "center", padding: "14px 16px", cursor: "pointer", background: isSelected ? "#e0f2fe" : "transparent", borderBottom: "1px solid #f3f4f6", userSelect: "none", transition: "background 0.12s" }}
                onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = "#f0f9ff"; }}
                onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = "transparent"; }}
              >
                {/* Radio circle */}
                <div style={{ width: 20, height: 20, border: `2px solid ${isSelected ? "#0891b2" : "#d1d5db"}`, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginRight: 14, transition: "border-color 0.12s" }}>
                  {isSelected && <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#0891b2" }} />}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: isSelected ? "#0369a1" : "#111827" }}>
                    Versión {v.version}
                  </div>
                  {v.definition && (
                    <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 3, fontFamily: "monospace", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {String(v.definition).substring(0, 55)}…
                    </div>
                  )}
                </div>
                {isSelected && (
                  <span style={{ fontSize: 10, fontWeight: 700, background: "#0891b2", color: "#fff", borderRadius: 5, padding: "2px 7px", flexShrink: 0 }}>Activa</span>
                )}
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div style={{ padding: "14px 20px", borderTop: "1px solid #e5e7eb", display: "flex", gap: 10, justifyContent: "flex-end", background: "#fff", flexShrink: 0 }}>
          <button
            onClick={handleClose}
            style={{ padding: "8px 20px", border: "1.5px solid #d1d5db", borderRadius: 7, background: "#fff", color: "#374151", cursor: "pointer", fontSize: 13, fontWeight: 500 }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = "#9ca3af"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "#d1d5db"; }}
          >
            Cancelar
          </button>
          {versions.length > 0 && (
            <button
              onClick={handleSave}
              disabled={selected == null}
              style={{ padding: "8px 22px", border: "none", borderRadius: 7, background: selected != null ? "#0891b2" : "#bae6fd", color: "#fff", cursor: selected != null ? "pointer" : "default", fontSize: 13, fontWeight: 600, display: "flex", alignItems: "center", gap: 6 }}
            >
              Aplicar versión
              {selected != null && (
                <span style={{ background: "rgba(255,255,255,0.25)", borderRadius: 10, padding: "1px 7px", fontSize: 12 }}>v{selected}</span>
              )}
            </button>
          )}
        </div>
      </div>

      <style>{`@keyframes dlg-spin { to { transform: rotate(360deg); } }`}</style>
    </>,
    document.body
  );
}

const DialogVersionsTemplate = (props) => {
  const { rows, requesting, fetchSuccess } = useSelector(state => state.Process);
  const dispatch = useDispatch();

  const versions = React.useMemo(() => {
    if (!rows || rows.length === 0) return [];
    return rows.map(r => ({
      version: r.VERSION,
      definition: r.FLOWDEFINITION || "",
    }));
  }, [rows, fetchSuccess]);

  if (!props.status || props.id < 0) return null;

  return (
    <VersionsPanel
      onClose={props.close}
      id={props.id}
      header={props.header}
      selectedRecord={props.selectedRecord}
      versions={versions}
      requesting={requesting}
      dispatch={dispatch}
    />
  );
};

export default DialogVersionsTemplate;
